export default {
    dataIterator: {
        rowsPerPageText: 'Elementi per pagina:',
        rowsPerPageAll: 'Tutti',
        pageText: '{0}-{1} di {2}',
        noResultsText: 'Nessun risultato trovato',
        nextPage: 'Pagina seguente',
        prevPage: 'Pagina precedente'
    },
    dataTable: {
        rowsPerPageText: 'Righe per pagina:'
    },
    noDataText: 'Nessun elemento disponibile',
    generic: {
        executeLogin: "Login",
        newAccount: "Nuovo utente? Registrati",
        station_statues:{
            ready: "on-line",
            offline: "off-line",
            out_of_service: "fuori servizio",
            maintenance: "manutenzione"
        },
        bay_statues: {
            READY: "Pronto",
            OUT_OF_SERVICE: "Fuori servizio",
            FAULTY: "Fuori servizio"
        },
        bay_uses: {
            SHARING: "bike-sharing",
            PRIVATE: "ricarica privata",
            CAR: "ricarica auto"
        },
        bay_usage_states: {
            PRELIEVO: "prelievo",
            RICARICA: "ricarica",
            RICONSEGNA: "riconsegna",
            NONE: "Occupato"
        }
    },
    Login: {
        newAccount: "Nuovo utente? Registrati",
        lostPassword: "Password dimenticata",
        enter: "Entra",
        loginSuccesfully: "Login eseguito con successo!",
        loginSuccesfullyTitle: "ACCESSO EFFETTUATO",
        errors: {
            unauthorized: "Username o Password errati!",
            not_enabled: "Utente non abilitato, controlla la tua e-mail per confermare la tua registrazione."
        }
    },
    ResetPassword: {
        usernamePlaceholder: "Username",
        emailPlaceholder: "E-mail",
        resetPassword: "Recupera Password",
        successTitleReset: "RICHIESTA RESET PASSWORD EFFETTUATA",
        successReset: "Richiesta di reset della password inviata alla tua e-mail. Guarda la tua e-mail e completa le operazioni",
        errors: {
            base: {
                no_user: "Account non trovato!",
                unexpected_error: "Errore non previsto, contattare l'amministrazione"
            }
        }
    },
    NewAccount: {
        residenceAddressPlaceholder: "Indirizzo residenza *",
        residenceNumberPlaceholder: "Numero residenza *",
        residenceCapPlaceholder: "Cap residenza *",
        residenceCityPlaceholder: "Città residenza *",
        residenceDistrictPlaceholder: "Provincia residenza *",
        residenceCountryPlaceholder: "Nazione residenza *",
        mobilePhonePlaceholder: "Telefono cellulare *",
        smscodePlaceholder: "Codice SMS *",
        namePlaceholder: "Nome *",
        surnamePlaceholder: "Cognome *",
        birthDatePlaceholder: "Data di nascita *",
        phonePlaceholder: "Telefono *",
        emailPlaceholder: "Indirizzo e-mail *",
        badgePlaceholder: "Smart Card",
        usernamePlaceholder: "Username *",
        passwordPlaceholder: "Password *",
        passwordConfirmationPlaceholder: "Ridigita la password *",
        languagePlaceholder: "Lingua",
        nationalIdentificationNumberPlaceholder: "Codice fiscale",
        newUser: "REGISTRAZIONE NUOVO UTENTE",
        infoAccess: "Informazioni di accesso",
        privacyConsent: "Ho letto l'INFORMATIVA PRIVACY ai sensi del regolamento UE 2016/679",
        regulationAcceptance: "Dichiaro di aver letto ed accetto il regolamento",
        Register: "Registrati",
        subscribeSuccesfullyTitle: "Account creato con successo!",
        subscribeSuccesfully: "Perfetto! Puoi iniziare ad utilizzare il servizio",
        titlePopupError: "Errore creazione account",
        messagePopupError: "Qualcosa è andato storto. Riprova!",
        successSubscription: "Account creato con successo.",
        closePopupPrivacy: "Chiudi",
        closePopupRegulation: "Chiudi",
        cell_verification_process: "Verifica del numero di telefono",
        check_phone_number: "Verifica telefono",
        sms_code_request: "Richiedi codice",
        invalidPhoneNumber: "Numero di telefono non valido",
        invalidSmsCode: "Codice non valido",
        errors: {
            firstname: {
                blank: "Campo obbligatorio"
            },
            lastname: {
                blank: "Campo obbligatorio"
            },
            birth_date: {
                blank: "Campo obbligatorio",
                should_be_adult: "non conforme"
            },
            email: {
                blank: "Campo obbligatorio",
                invalid: "Formato mail non valido"
            },
            username: {
                blank: "Campo obbligatorio",
                taken: "Già presente nel sistema"
            },
            password: {
                blank: "Campo obbligatorio",
                invalid: "La password deve essere lunga almeno 10 caratteri e deve contenere lettere e numeri",
                must_same_password_confirm: "Password e conferma password devono coincidere"
            },
            password_confirmation: {
                confirmation: "Password e conferma password devono coincidere",
                blank: "Campo obbligatorio"

            },
            gdpr_role: {
                inclusion: "Campo obbligatorio"
            },
            regulation_acceptance: {
                inclusion: "Campo obbligatorio"
            },
            residence_address: {
                blank: "Campo obbligatorio"
            },
            residence_number: {
                blank: "Campo obbligatorio"
            },
            residence_cap: {
                blank: "Campo obbligatorio"
            },
            residence_city: {
                blank: "Campo obbligatorio"
            },
            residence_district: {
                blank: "Campo obbligatorio"
            },
            residence_country: {
                blank: "Campo obbligatorio"
            },
            national_identification_number: {
                taken: "Codice fiscale già presente nel sistema",
                blank: "Campo obbligatorio",
                invalid_format: "Formato non corretto"
            }


        }

    },
    Application: {
        account: "Account",
        statistics: "Statistiche",
        logout: "Logout",
        version: "Vers.",
        rules: "Condizioni",
        closePopupRules: "Chiudi"
    },
    PopUpStation: {
        goToStation: "Vai alla stazione",
        close: "Chiudi",
        tableData: {
            name: "Stazione"
        },
        noResult: "Stazione non trovata"
    },
    StationInfo: {
        name: "Stazione",
        availableVehicles: "Veicoli disponibili",
        totalCount: "Posti totali",
        freeBay: "Posti liberi",
        address: "Indirizzo"
    },
    Station: {
        loginToStation: "Accedi alla stazione",
        position: "Posto",
        bayUsageBusyState: "Occupato",
        availableFor: "Disponibile per ",
        usages: {
            private: "Ricarica e-bike privata",
            vehicle_private: "Ricarica veicolo elettrico privato",
            sharing: "Ricarica e-bike pubblica",
            car: "Ricarica veicolo elettrico",
            charger: "Posto ricarica"
        }
    },
    BasePopUp: {
        close: "Chiudi"
    },
    StationLogin: {
        warningMessage: "ATTENZIONE!",
        message: "Inserisci il codice di accesso presente sul display della Stazione.",
        signIn: "Accedi",
        codePlaceholder: "Codice Accesso",
        goodJobMessage: "Ben fatto!",
        messageSuccessLogin: "Ti sei autenticato correttamente alla Stazione",
        messageSuccessLoginNoMonitorCode: "Ti sei autenticato correttamente alla stazione, prosegui con i pulsanti sulla colonnina",
        labelStation: "",
        instructions: "Continua seguendo le istruzioni sul display della Stazione...",
        errorMessage: "Il codice inserito è errato e non corrisponde a quello presente sul display della Stazione. Riprova cliccando sul tasto seguente...",
        retry: "Riprova"
    },
    Account: {
        editUser: "MODIFICA UTENTE",
        editAccount: "Informazioni di accesso",
        namePlaceholder: "Nome *",
        surnamePlaceholder: "Cognome *",
        birthDatePlaceholder: "Data di nascita *",
        phonePlaceholder: "Telefono",
        residenceAddressPlaceholder: "Indirizzo residenza *",
        residenceNumberPlaceholder: "Numero residenza *",
        residenceCapPlaceholder: "Cap residenza *",
        residenceCityPlaceholder: "Città residenza *",
        residenceDistrictPlaceholder: "Provincia residenza *",
        residenceCountryPlaceholder: "Nazione residenza *",
        nationalIdentificationNumberPlaceholder: "Codice Fiscale",
        badgePlaceholder: "Smart Card",
        emailPlaceholder: "E-mail *",
        languagePlaceholder: "Lingua",
        update: "Aggiorna",
        updateSuccesfullyTitle: "Ben fatto!",
        updateSuccesfully: "Informazioni account aggiornate con successo.",
        confirmNewPasswordPlaceholder: "Conferma password *",
        newPasswordPlaceholder: "Nuova Password *",
        currentPasswordPlaceholder: "Password attuale *",
        updateSuccesfullyAccountTitle: "Ben fatto!",
        updateAccountSuccesfully: "Informazioni di accesso aggiornate",
        errors:{
            lastname:{
                blank: "campo obbligatorio"
            },
            birth_date: {
                blank: "Campo obbligatorio",
                should_be_adult: "non conforme"
            },
            email: {
                blank: "campo obbligatorio"
            },
            password: {
                must_same_password_confirm: "Password e conferma password devono coincidere",
                blank: "campo obbligatorio",
                invalid: "La password deve essere lunga almeno 10 caratteri e deve contenere lettere e numeri"
            },
            old_password: {
                unauthorized: "Password corrente non corretta",
                blank: "Campo obbligatorio"
            },
            password_confirmation: {
                blank: "Campo obbligatorio",
                confirmation: "Password e conferma password devono coincidere"
            },
            residence_address: {
                blank: "Campo obbligatorio"
            },
            residence_number: {
                blank: "Campo obbligatorio"
            },
            residence_cap: {
                blank: "Campo obbligatorio"
            },
            residence_city: {
                blank: "Campo obbligatorio"
            },
            residence_district: {
                blank: "Campo obbligatorio"
            },
            residence_country: {
                blank: "Campo obbligatorio"
            },
            national_identification_number: {
                taken: "Codice fiscale già presente nel sistema",
                blank: "Campo obbligatorio",
                invalid_format: "Formato non corretto"
            }

        }

    },
    Statistics: {
        servicePlaceholder: "Servizio",
        dateFromPlaceholder: "Da",
        dateToPlaceholder: "A",
        tableHeaders: {
            vehicle: "Veicolo"
        },
        services: {
            sharing_unit: "Bike-sharing",
            car_unit: "Ricariche auto",
            recharge_unit: "Ricariche veicoli"
        },
        noResult: "Nessun risultato",
        showMore: "Mostra altri risultati"
    },
    NewPassword: {
        passwordPlaceholder: "Nuova password",
        passwordConfirmationPlaceholder: "Conferma Nuova password",
        noTokenError: "Token per reset password non trovato",
        successPasswordChanged: "Ora puoi effettuare il login con la tua nuova password",
        successPasswordChangedTitle: "PASSWORD CAMBIATA",
        changePassword: "Cambia password",
        errors: {
            password: {
                blank: "Campo obbligatorio",
                invalid: "La password deve essere lunga almeno 10 caratteri e deve contenere lettere e numeri",
                must_same_password_confirm: "Password e conferma password devono coincidere"
            }
        }
    },
    AppUpgrade: {
        newUpdates: "Aggiornamento",
        wouldYouUpgrade: "E' disponibile una nuova versione, vuoi aggiornare l'applicazione?",
        update: "Aggiorna",
        discardUpdate: "Annulla"

    },
    AddToHome: {
        add: "Aggiungi",
        discardAdd: "Annulla",
        installApp: "Installa applicazione",
        installAppMessage: "Per una migliore esperienza ti consigliamo di aggiungere l'applicazione alla schermata home",
        howToInstall: "Per una migliore esperienza ti consigliamo di aggiungere l'applicazione alla schermata home",
        ok: "OK"

    },
    App: {
        offlineMessage: "Per utilizzare l'applicazione è necessaria la connessione ad internet",
        offlineMessageTitle: "OPS! SEI OFFLINE"
    },
    Credit: {
        availableCredit: "SALDO DISPONIBILE",
        rechargeCredit: "RICARICA CREDITO",
        paymentsArchive: "Archivio pagamenti",
        currency: "€",
        noPaymentMethodsMessage: "Non è possibile effettuare la ricarica del credito perchè non sono disponibili metodi di pagamento",
        noPaymentMethods: "NESSUN METODO DI PAGAMENTO"
    },
    Braintree: {
        recharge: "Ricarica",
        successPayment: "BEN FATTO!",
        successPaymentMessage: "Pagamento avvenuto con successo",
        errorPayment: "ERRORE!",
        errorPaymentMessage: "Errore nell'elaborazione della richiesta di pagamento"
    },
    Stripe: {
        recharge: "Ricarica",
        successPayment: "BEN FATTO!",
        successPaymentMessage: "Pagamento avvenuto con successo",
        errorPayment: "ERRORE!",
        errorPaymentMessage: "Errore nell'elaborazione della richiesta di pagamento",
        waitingPayment: "ATTENDERE",
        waitingPaymentMessage: "Elaborazione del pagamento in corso...",
        unexpectedError: "Errore inaspettato",
        processingPayment: "Pagamento in corso"
    },
    Stations: {
        labelStation: "Stazione",
        address: "Indirizzo",
        totalSeats: "Posti totali",
        availableSeats: "Posti liberi",
        availableVehicles: "Veicoli disponibili"

    },
    UpdateRequestedUserInfo: {
        warningMessage: "Ti invitiamo a completare il tuo profilo utente con le informazioni mancanti"
    },

    languages: {
        "IT": "Italiano",
        "EN": "English",
        "ES": "Español",
        "DE": "Deutsch"
    },

    CurrentSharing:{
        duration:"Tempo utilizzo",
        startBay:"Stazione di partenza",
        takeAt:"Data/ora inizio utilizzo",
        title: "Informazioni Utilizzo",
        bike_lock:{
            button:"SBLOCCA LUCCHETTO",
            success_message:"Confermato Sbloccaggio lucchetto",
            failure_message:"Sblocco fallito, ritentare."
        }
    }
};
